const domaine = 'COMPTE_TITRES'

export const AJOUTER_COMPTE_TITRES = `${domaine}/AJOUTER_COMPTE_TITRES`
